import React from 'react';
import { InputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib/input-number';
import { isNil } from 'lodash';

export type InputMoneyProps = InputNumberProps;

const InputRate = (props: InputMoneyProps) => {
  return (
    <InputNumber
      controls={false}
      className='border-color-gray'
      precision={5}
      formatter={(value, _info) => {
        if (isNil(value) || value === '') return '';

        const strValue = String(value);
        const parts = strValue.split('.');
        const intPart = parts[0];
        const decPart = parts[1];

        // Add space as thousands separator
        const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        // Return with decimal part if it exists
        if (decPart !== undefined) {
          return `${formattedInt},${decPart}`;
        }
        return formattedInt;
      }}
      parser={(value) => {
        if (!value) return '';

        // Remove spaces and percent sign
        let cleaned = value.replace(/\s/g, '').replace(/%/g, '');

        // Replace comma with dot for consistent decimal handling
        cleaned = cleaned.replace(/,/g, '.');

        // Parse to number
        const num = Number.parseFloat(cleaned);
        return isNaN(num) ? '' : num;
      }}
      decimalSeparator=","
      suffix="%"
      min={props.min}
      {...props}
    />
  );
};

export default InputRate;
